import type { BaseAPI } from '@api/base';
import type { Configuration } from '@api/configuration';
import type { interfaces } from 'inversify';

export function apiFactory<T extends BaseAPI>(
	type: interfaces.Newable<T>,
	configuration: unknown
) {
	return (_: interfaces.Context): BaseAPI => {
		const apiType = type as typeof BaseAPI;

		return new apiType(configuration);
	};
}
